export const SURVEY_STATUSES = {
  APPROVED: { name: 'approved' },
  COMPLETED: { id: 7, name: 'completed' },
  DRAFT: { id: 6, name: 'draft' },
  LIVE: { id: 1 },
  ARCHIVED: { id: 15, name: 'archived' },
} as const;

export const ELIGIBLE_STATUSES_FOR_CHANGE_NON_ADMIN = {
  [SURVEY_STATUSES.APPROVED.name]: [
    SURVEY_STATUSES.COMPLETED,
    SURVEY_STATUSES.DRAFT,
  ],
  [SURVEY_STATUSES.COMPLETED.name]: [SURVEY_STATUSES.DRAFT],
  [SURVEY_STATUSES.DRAFT.name]: [SURVEY_STATUSES.COMPLETED],
  [SURVEY_STATUSES.ARCHIVED.name]: [SURVEY_STATUSES.DRAFT],
};

export const ELIGIBLE_STATUSES_FOR_CHANGE_ADMIN = {
  [SURVEY_STATUSES.APPROVED.name]: [
    SURVEY_STATUSES.COMPLETED,
    SURVEY_STATUSES.DRAFT,
    SURVEY_STATUSES.ARCHIVED,
  ],
  [SURVEY_STATUSES.COMPLETED.name]: [
    SURVEY_STATUSES.DRAFT,
    SURVEY_STATUSES.ARCHIVED,
  ],
  [SURVEY_STATUSES.DRAFT.name]: [
    SURVEY_STATUSES.COMPLETED,
    SURVEY_STATUSES.ARCHIVED,
  ],
  [SURVEY_STATUSES.ARCHIVED.name]: [SURVEY_STATUSES.DRAFT],
};

export const IMAGE_VIDEO_TOOLTIP_COPY =
  'Upload either image or video files. Suggested formats are jpeg/png under 5mb for images or mp4 under 30mb for video.';
